import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { RouteSelector } from 'src/components/routeSelector/RouteSelector';
import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { RouteProps } from 'src/types/router';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <RouteSelector />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
];

export const HOME_ROUTE: RouteProps = {
  path: appRoutes.root,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [ReactRouteAccessKey.anyAuthorized],
};
